import _objectSpread from "@babel/runtime-corejs2/helpers/esm/objectSpread";
import { combineReducers } from 'redux';

var globalReducer = function globalReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return state;
};
/**
 * This function sets the global reducer of the application
 * @param {Function} reducer
 */


export var initialiseGlobalReducer = function initialiseGlobalReducer(reducer) {
  globalReducer = reducer;
};
/**
 * @function createReducer - Combine reducer for given page level component with global ones
 * @param {Object} injectedReducers
 * @returns {function}
 */

export default function createReducer(injectedReducers) {
  return combineReducers(_objectSpread({
    global: globalReducer
  }, injectedReducers));
}
export var globalDataStructure = ['global'];